import extendNode from '../extendNode.mjs'
import useCategoryNode from '../_CATEGORY/useCategoryNode.jsx'
import meta from './metaDoDe.mjs'

export default () => {
    const CategoryNode = useCategoryNode()

    return extendNode(CategoryNode, {
        ...meta,

        canMountType(map, node, type) {
            return /^(CAT|DE)$/.test(type)
        },

        menuItemsInsertCommon(map, node) {
            return [
                {type: 'CAT'},
            ]
        },

        menuItemsInsertConcept(map, node) {
            return [
                {type: 'DE'},
            ]
        },
    })
}
